import { render, staticRenderFns } from "./ItemFormIngredientList.vue?vue&type=template&id=44fafe4a&scoped=true&"
import script from "./ItemFormIngredientList.vue?vue&type=script&lang=js&"
export * from "./ItemFormIngredientList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fafe4a",
  null
  
)

export default component.exports